define(["underscore","backbone","pug-runtime","bluebird","knockout","path-browserify"], function(__WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__57__, __WEBPACK_EXTERNAL_MODULE__316__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 311);
/******/ })
/************************************************************************/
/******/ ({

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(312);


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "_package", {
  enumerable: true,
  get: function get() {
    return _package.default;
  }
});
Object.defineProperty(exports, "FilePicker", {
  enumerable: true,
  get: function get() {
    return _index.default;
  }
});

var _package = _interopRequireDefault(__webpack_require__(313));

var _index = _interopRequireDefault(__webpack_require__(314));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 313:
/***/ (function(module) {

module.exports = {"name":"@bingads-webui/file-picker","description":"Please find documentation and tutorial at http://bingadsinternal.azurewebsites.net/sharedcomponents/client/jsdoc/file-picker","version":"1.4.1","main":"dist/index","license":"UNLICENSED","peerDependencies":{"backbone":"^1.3.3","bluebird":"3.5.0","knockout":"^3.4.1","path-browserify":"^0.0.0","underscore":"^1.8.3"},"devDependencies":{"@bingads-webui-test/iframe-driver":"^1.3.1","@bingads-webui/file-picker":"file:.","backbone":"1.3.3","bluebird":"3.5.0","chai":"3.5.0","jquery":"3.1.1","knockout":"3.4.1","path-browserify":"0.0.0","underscore":"1.8.3"}};

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _knockout = _interopRequireDefault(__webpack_require__(57));

var _backbone = _interopRequireDefault(__webpack_require__(9));

var _index = _interopRequireDefault(__webpack_require__(315));

var _index2 = _interopRequireDefault(__webpack_require__(317));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FilePicker =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(FilePicker, _Backbone$View);

  function FilePicker() {
    _classCallCheck(this, FilePicker);

    return _possibleConstructorReturn(this, _getPrototypeOf(FilePicker).apply(this, arguments));
  }

  _createClass(FilePicker, [{
    key: "initialize",

    /**
     *
     * @param {object} options the options to build a filepicker instance.
     *   See the detail fields below.
     * @param {boolean} options.isNative will use the browser native button when it is set to true.
     * Otherwise will use the customized elements and hide the native ones.
     * @param {array} options.allowedFileExtensions the allowed file extensions. An array of strings.
     * Example: ['.txt', '.exe']. Will accept all file extensions if this field is not set.
     * @param {function} options.validator function to validate your file. The file object as
     * paramter. Return string for true is to raise an error. If you return true will use the
     * predefined error message.
     * @param {object} options.i18n object: contains getString function for i18n.
     * @param {function} options.i18n.getString pass a key(and model if needed) and returns a string.
     * @param {function} options.displayFilePath an enum of 'full' or 'filename', indicating the
     * display name of the chosen file in customized elements
     *
     * @event FilePicker#changed triggered when file is changed.
     * @event FilePicker#cleared triggered when file is cleared.
     * @event FilePicker#error.extension triggered when file extension is invalid.
     *
     * @returns {undefined} no return value
     *
     */
    value: function initialize(_ref) {
      var _this = this;

      var _ref$isNative = _ref.isNative,
          isNative = _ref$isNative === void 0 ? false : _ref$isNative,
          _ref$allowedFileExten = _ref.allowedFileExtensions,
          allowedFileExtensions = _ref$allowedFileExten === void 0 ? [] : _ref$allowedFileExten,
          validateFileExtensionsFailedMessage = _ref.validateFileExtensionsFailedMessage,
          _ref$validator = _ref.validator,
          validator = _ref$validator === void 0 ? _underscore.default.noop : _ref$validator,
          _ref$i18n = _ref.i18n,
          i18n = _ref$i18n === void 0 ? {} : _ref$i18n,
          _ref$displayFilePath = _ref.displayFilePath,
          displayFilePath = _ref$displayFilePath === void 0 ? 'full' : _ref$displayFilePath,
          _ref$enableMultiple = _ref.enableMultiple,
          enableMultiple = _ref$enableMultiple === void 0 ? false : _ref$enableMultiple;
      this.isNative = isNative;
      this.i18n = i18n;
      this.allowedFileExtensions = [];
      this.enableMultiple = enableMultiple;

      if (!_underscore.default.isFunction(i18n.getString)) {
        this.i18n = {
          getString: _underscore.default.identity
        };
      }

      if (!_underscore.default.isEmpty(allowedFileExtensions)) {
        if (_underscore.default.isArray(allowedFileExtensions)) {
          this.allowedFileExtensions = allowedFileExtensions;
        } else {
          throw new Error('allowedFileExtensions accepts array of strings only.');
        }
      }

      this.viewModel = new _index.default({
        i18n: this.i18n,
        validator: validator,
        allowedFileExtensions: this.allowedFileExtensions,
        validateFileExtensionsFailedMessage: validateFileExtensionsFailedMessage,
        getFileObject: function getFileObject() {
          return _this.fileObject;
        },
        getFileObjects: function getFileObjects() {
          return _this.fileObjects;
        },
        trigger: this.trigger.bind(this),
        displayFilePath: displayFilePath,
        enableMultiple: this.enableMultiple
      });
      this.fileInputCssId = _underscore.default.uniqueId('el_fileinput_');
    }
  }, {
    key: "render",
    value: function render() {
      this.$el.html((0, _index2.default)({
        fileInputCssId: this.fileInputCssId,
        i18n: this.i18n,
        isNative: this.isNative,
        acceptString: this.allowedFileExtensions.join(),
        enableMultiple: this.enableMultiple
      }));

      _knockout.default.applyBindings(this.viewModel, this.el);

      return this;
    }
  }, {
    key: "removeFile",
    value: function removeFile() {
      this.viewModel.filePath('');
    }
  }, {
    key: "addExternalValidationErrors",
    value: function addExternalValidationErrors(msg) {
      this.viewModel.errors.push(msg);
    }
  }, {
    key: "hasErrors",
    value: function hasErrors() {
      return this.viewModel.hasErrors();
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'click .remove-file': 'removeFile'
      };
    }
    /**
     * @returns {string} the full path file
     */

  }, {
    key: "filePath",
    get: function get() {
      return this.viewModel.filePath();
    }
    /**
     * @returns {Object} the object to describe the file. Refer https://developer.mozilla.org/en-US/docs/Web/API/File for more details.
     * @example
     * {
     *    lastModified: 1465909575599,
     *    lastModifiedDate: Tue Jun 14 2016 21:06:15 GMT+0800 (China Standard Time),
     *    name: 'test.txt',
     *    size: 3,
     *    type: "",
     *    webkitRelativePath: ''
     * }
     */

  }, {
    key: "fileObject",
    get: function get() {
      return _underscore.default.first(this.fileObjects);
    }
  }, {
    key: "fileObjects",
    get: function get() {
      return _underscore.default.first(this.$("#".concat(this.fileInputCssId))).files;
    }
  }]);

  return FilePicker;
}(_backbone.default.View);

exports.default = FilePicker;

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _knockout = _interopRequireDefault(__webpack_require__(57));

var _pathBrowserify = _interopRequireDefault(__webpack_require__(316));

var _bluebird = _interopRequireDefault(__webpack_require__(17));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function validatorDecorator(validator, reasonText, file, context) {
  return _bluebird.default.resolve(validator(file)).then(function (returnedError) {
    return new _bluebird.default(function (resolve, reject) {
      if (returnedError) {
        reject(new Error(_underscore.default.isString(returnedError) ? returnedError : reasonText));
      } else {
        resolve(file);
      }
    });
  }).bind(context);
}

var ViewModel =
/*#__PURE__*/
function () {
  function ViewModel(_ref) {
    var _this = this;

    var i18n = _ref.i18n,
        allowedFileExtensions = _ref.allowedFileExtensions,
        validateFileExtensionsFailedMessage = _ref.validateFileExtensionsFailedMessage,
        validator = _ref.validator,
        getFileObject = _ref.getFileObject,
        getFileObjects = _ref.getFileObjects,
        trigger = _ref.trigger,
        displayFilePath = _ref.displayFilePath,
        enableMultiple = _ref.enableMultiple;

    _classCallCheck(this, ViewModel);

    this.i18n = i18n;
    this.allowedFileExtensions = _underscore.default.map(allowedFileExtensions, function (ext) {
      return ext.toUpperCase();
    });
    this.validateFileExtensionsFailedMessage = validateFileExtensionsFailedMessage;
    this.validator = validator;
    this.getFileObject = getFileObject;
    this.getFileObjects = getFileObjects;
    this.trigger = trigger;
    this.enableMultiple = enableMultiple;
    this.filePath = _knockout.default.observable('');
    this.errors = _knockout.default.observableArray();
    this.hasErrors = _knockout.default.computed(function () {
      return _this.errors().length > 0;
    }, this);
    this.displayFilePath = _knockout.default.computed(function () {
      var fullPath = _this.filePath();

      return _underscore.default.result({
        full: fullPath,
        filename: function filename() {
          return fullPath.replace(/^.*[\\\/]/, '');
        } //eslint-disable-line

      }, displayFilePath);
    });

    if (enableMultiple) {
      // use change event when multiple is enabled.
      // value subscribe doens't work when first selected file doesn't change.
      this.onInputChange = function () {
        _this.handleInputChange();
      };
    } else {
      this.filePath.subscribe(function (newFilePath) {
        _this.handleInputChange(newFilePath);
      });
    }
  }

  _createClass(ViewModel, [{
    key: "handleInputChange",
    value: function handleInputChange(newFilePath) {
      var _this2 = this;

      // for backward compatibility, here still use getFileObject to get selected file.
      // otherwise there are many feature test codes needing fix.
      var files = [];

      if (this.enableMultiple) {
        files = this.getFileObjects();
      } else {
        var file = this.getFileObject();

        if (file) {
          files.push(file);
        }
      }

      this.resetStatus();
      this.trigger('changed', newFilePath);

      if (_underscore.default.isEmpty(files)) {
        this.trigger('cleared');
      } else {
        var validatingPromiseArr = [];

        _underscore.default.each(files, function (file) {
          validatingPromiseArr.push(_this2.validateExtension(file).then(function () {
            _this2.validateFile(file);
          }));
        });

        _bluebird.default.all(validatingPromiseArr).then(function () {
          return _this2.trigger('validated');
        }).catch(function (reason) {
          _this2.validationDidFail(reason);
        });
      }
    }
  }, {
    key: "validateExtension",
    value: function validateExtension(file) {
      return validatorDecorator(this.extensionValidator.bind(this), this.i18n.getString('FilePicker_FileExtensionInvalid', {
        allowedFileExtensions: this.allowedFileExtensions
      }), file, this);
    }
  }, {
    key: "validateFile",
    value: function validateFile(file) {
      return validatorDecorator(this.validator, this.i18n.getString('FilePicker_FileInvalid'), file, this);
    }
  }, {
    key: "validationDidFail",
    value: function validationDidFail(reason) {
      this.errors.push(reason.message);
    }
  }, {
    key: "resetStatus",
    value: function resetStatus() {
      this.errors([]);
    }
  }, {
    key: "extensionValidator",
    get: function get() {
      var _this3 = this;

      return function (file) {
        if (_underscore.default.isEmpty(_this3.allowedFileExtensions)) {
          return false;
        }

        var extension = _pathBrowserify.default.extname(file.name).toUpperCase();

        if (_underscore.default.indexOf(_this3.allowedFileExtensions, extension) === -1) {
          _this3.trigger('error.extension');

          return _this3.validateFileExtensionsFailedMessage || true;
        }

        return null;
      };
    }
  }]);

  return ViewModel;
}();

exports.default = ViewModel;

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__316__;

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(13);

function template(locals) {
  var pug_html = "",
      pug_mixins = {},
      pug_interp;
  ;
  var locals_for_with = locals || {};
  (function (acceptString, enableMultiple, fileInputCssId, i18n, isNative) {
    pug_html = pug_html + "<div" + pug.attr("class", pug.classes([isNative ? 'hidden' : ''], [true]), false, true) + "><label" + (" class=\"btn btn-default file-picker-btn clickable\"" + pug.attr("for", fileInputCssId, true, true) + " data-bind=\"css: { &quot;error&quot;: hasErrors}\" role=\"button\" tabindex=\"0\"") + ">" + pug.escape(null == (pug_interp = i18n.getString('FilePicker_ButtonText_ChooseFile')) ? "" : pug_interp) + "</label><span class=\"file-text\" data-bind=\"text: displayFilePath, css: { error: hasErrors}\"></span><a class=\"remove-file\" href=\"javascript:void(0)\" data-bind=\"visible: filePath\" role=\"button\">" + pug.escape(null == (pug_interp = i18n.getString('FilePicker_ButtonText_RemoveFile')) ? "" : pug_interp) + "</a></div>";

    if (enableMultiple) {
      pug_html = pug_html + "<input" + (pug.attr("class", pug.classes(["file-picker-input", isNative ? '' : 'hidden'], [false, true]), false, true) + " type=\"file\" data-bind=\"css: { error: hasErrors }, event: { change: onInputChange }\"" + pug.attr("id", fileInputCssId, true, true) + pug.attr("accept", acceptString, true, true) + pug.attr("multiple", true, true, true)) + ">";
    } else {
      pug_html = pug_html + "<input" + (pug.attr("class", pug.classes(["file-picker-input", isNative ? '' : 'hidden'], [false, true]), false, true) + " type=\"file\" data-bind=\"css: { error: hasErrors }, value: filePath\"" + pug.attr("id", fileInputCssId, true, true) + pug.attr("accept", acceptString, true, true)) + ">";
    }

    pug_html = pug_html + "<!-- ko foreach: errors--><div class=\"error\" role=\"alert\" data-bind=\"text: $data\"></div><!-- /ko-->";
  }).call(this, "acceptString" in locals_for_with ? locals_for_with.acceptString : typeof acceptString !== "undefined" ? acceptString : undefined, "enableMultiple" in locals_for_with ? locals_for_with.enableMultiple : typeof enableMultiple !== "undefined" ? enableMultiple : undefined, "fileInputCssId" in locals_for_with ? locals_for_with.fileInputCssId : typeof fileInputCssId !== "undefined" ? fileInputCssId : undefined, "i18n" in locals_for_with ? locals_for_with.i18n : typeof i18n !== "undefined" ? i18n : undefined, "isNative" in locals_for_with ? locals_for_with.isNative : typeof isNative !== "undefined" ? isNative : undefined);
  ;
  return pug_html;
}

;
module.exports = template;

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__57__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ })});;
